import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Store from "../../../utils/Store";
import { useStoreState } from "pullstate";
import { useRef, useEffect } from "react";
import useCallOrchestrator from "../utils/services/useCallOrchestrator";
import { useCopilotChat, useCopilotMessagesContext } from "@copilotkit/react-core";
import { Role, TextMessage } from "@copilotkit/runtime-client-gql";
var CustomRenderSuggestionsList = function CustomRenderSuggestionsList(props) {
  var onSuggestionClick = props.onSuggestionClick;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo,
        assistantThreadId: s.assistantThreadId,
        patientDetail: s.patientDetail,
        customSuggestions: s.customSuggestions
      };
    }),
    userInfo = _useStoreState.userInfo,
    assistantThreadId = _useStoreState.assistantThreadId,
    patientDetail = _useStoreState.patientDetail,
    customSuggestions = _useStoreState.customSuggestions;
  var _useCopilotMessagesCo = useCopilotMessagesContext(),
    messages = _useCopilotMessagesCo.messages;
  var messagesRef = useRef(messages);
  useEffect(function () {
    messagesRef.current = messages;
  }, [messages]);
  var patientDetailRef = useRef(patientDetail);
  useEffect(function () {
    patientDetailRef.current = patientDetail;
  }, [patientDetail]);
  var assistantThreadIdRef = useRef(assistantThreadId);
  useEffect(function () {
    assistantThreadIdRef.current = assistantThreadId;
  }, [assistantThreadId]);
  var callOrchestrator = useCallOrchestrator(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, assistantThreadIdRef.current);
  var _useCopilotChat = useCopilotChat(),
    appendMessage = _useCopilotChat.appendMessage;
  var assistantMode = useStoreState(Store, function (s) {
    return s.assistantMode;
  });
  var handleOrchestrator = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var isMessageSaved, attempts, maxAttempts, intervalMs, lastUserMessage, lastUserMessageId, params, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            Store.update(function (s) {
              s.isUsingOrchestrator = true;
            });
            isMessageSaved = false;
            attempts = 0;
            maxAttempts = 100;
            intervalMs = 1000; // ✅ Poll every 1 second, max 10 tries
          case 1:
            if (!(attempts < maxAttempts && !isMessageSaved)) {
              _context.n = 4;
              break;
            }
            lastUserMessage = messagesRef.current.sort(function (a, b) {
              return a.createdAt - b.createdAt;
            }).findLast(function (message) {
              return message.role === "user";
            });
            lastUserMessageId = lastUserMessage === null || lastUserMessage === void 0 ? void 0 : lastUserMessage.id;
            if (!(lastUserMessageId === Store.getRawState().lastSavedUserMessageId)) {
              _context.n = 2;
              break;
            }
            isMessageSaved = true;
            return _context.a(3, 4);
          case 2:
            _context.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, intervalMs);
            });
          case 3:
            attempts++;
            _context.n = 1;
            break;
          case 4:
            if (!isMessageSaved) {
              console.warn("⚠️ Message not saved within timeout. Proceeding anyway...");
            }

            // ✅ Continue to orchestrator call
            if (!isMessageSaved) {
              _context.n = 6;
              break;
            }
            params = {
              patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id
            };
            Store.update(function (s) {
              s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                status: "request_started",
                conversation_id: Store.getRawState().assistantThreadId
              };
              s.wsEvents[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = [];
            });
            _context.n = 5;
            return callOrchestrator.mutateAsync(params, {
              onSuccess: function onSuccess(data) {
                Store.update(function (s) {
                  s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                    patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                    status: "request_success",
                    conversation_id: Store.getRawState().assistantThreadId
                  };
                });
                var patientId = patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id;
                var attempts = 0;
                var maxAttempts = 6 * 60; // 6 minutes

                var pollInterval = setInterval(function () {
                  var _Store$getRawState$cu;
                  attempts++;
                  var currentStatus = (_Store$getRawState$cu = Store.getRawState().currentPatientsUsingOrchestrator[patientId]) === null || _Store$getRawState$cu === void 0 ? void 0 : _Store$getRawState$cu.status;

                  // Check if status has changed from "request_success"
                  if (currentStatus && currentStatus !== "request_success") {
                    clearInterval(pollInterval);
                    return;
                  }

                  // Check if we've reached max attempts (100 seconds)
                  if (attempts >= maxAttempts) {
                    Store.update(function (s) {
                      s.currentPatientsUsingOrchestrator[patientId] = _objectSpread(_objectSpread({}, s.currentPatientsUsingOrchestrator[patientId]), {}, {
                        status: "timeout"
                      });
                    });
                    appendMessage(new TextMessage({
                      role: Role.Assistant,
                      content: "Timeout: LLM orchestrator is taking too long to respond. Please try again.",
                      id: "".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
                    }), {
                      followUp: false
                    });
                    clearInterval(pollInterval);
                    return;
                  }
                }, 1000); // Check every 1 second
              },
              onError: function onError(error) {
                Store.update(function (s) {
                  s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                    patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                    status: "request_failed",
                    conversation_id: Store.getRawState().assistantThreadId
                  };
                });
                console.error("The task is failed. Please try again.", error);
                appendMessage(new TextMessage({
                  role: Role.Assistant,
                  content: "The task is failed. Please try again.",
                  id: "".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
                }), {
                  followUp: false
                });
              }
            });
          case 5:
            response = _context.v;
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleOrchestrator() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(suggestion) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // onSuggestionClick(suggestion.message);
            appendMessage(new TextMessage({
              role: Role.User,
              content: suggestion.message,
              id: "ck-".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
            }), {
              followUp: false
            });
            Store.update(function (s) {
              s.hasUserSentMessage = true;
              s.customSuggestions = [];
              s.lastAssitantMessageId = "";
            });
            if (!(assistantMode === "workflow")) {
              _context2.n = 1;
              break;
            }
            _context2.n = 1;
            return handleOrchestrator();
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isPatientUsingOrchestrator = Store.getRawState().currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id];
  var isDisabled = isPatientUsingOrchestrator && isPatientUsingOrchestrator.status !== "completed" && isPatientUsingOrchestrator.status !== "request_failed" && (isPatientUsingOrchestrator === null || isPatientUsingOrchestrator === void 0 ? void 0 : isPatientUsingOrchestrator.status) !== "timeout" && (isPatientUsingOrchestrator === null || isPatientUsingOrchestrator === void 0 ? void 0 : isPatientUsingOrchestrator.conversation_id) === Store.getRawState().assistantThreadId;
  if (isDisabled || assistantMode === "simple") {
    return null;
  }
  if (isDisabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2 p-2"
  }, customSuggestions === null || customSuggestions === void 0 ? void 0 : customSuggestions.map(function (suggestion, index) {
    return /*#__PURE__*/React.createElement("button", {
      key: suggestion.title + index,
      onClick: function onClick() {
        handleSubmit(suggestion);
      },
      disabled: suggestion.title === "Loading...",
      className: "flex justify-between items-center cursor-pointer rounded-full hover:border-teal-400 hover:text-gray-100 dark:bg-teal-900  text-gray-800 border border-teal-400 dark:text-teal-300 dark:!border-teal-800 hover:bg-teal-400 dark:hover:bg-teal-500 dark:hover:text-white w-fit px-3 py-1.5 text-sm"
    }, suggestion.title);
  }));
};
export default CustomRenderSuggestionsList;